module.exports = __webpack_public_path__ + "img/fixed_2.0f9f83a3.jpg";